module.exports = __webpack_public_path__ + "img/ldr-logo-with-title.489c8740.png";